export default [
    {
        'id': 1,
        'name': 'Alex Dolgove',
        'thumb': 'http://via.placeholder.com/256x256',
    }, {
        'id': 2,
        'name': 'Domnic Harris',
        'thumb': 'http://via.placeholder.com/256x256',
    }, {
        'id': 3,
        'name': 'Garry Sobars',
        'thumb': 'http://via.placeholder.com/256x256',
    }, {
        'id': 4,
        'name': 'Stella Johnson',
        'thumb': 'http://via.placeholder.com/256x256',
    }, {
        'id': 5,
        'name': 'John Smith',
        'thumb': 'http://via.placeholder.com/256x256',
    }, {
        'id': 6,
        'name': 'Domnic Brown',
        'thumb': 'http://via.placeholder.com/256x256',
    }
]


// WEBPACK FOOTER //
// ./app/routes/todo/data/users.js